import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ai-templates/ComponentBrowser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ai-templates/QuickStart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ai-templates/RecentlyViewed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ai-templates/TypeIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ai-templates/TypeNav.tsx");
